import { create } from 'zustand'
import { getMesActual } from '../utils/dashboardUtils';

const dashboardStore = create((set, get) => ({
  isLoading: true,
  error: null,

  // Filtros
  fechaInicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
  fechaFin: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0],
  idSucursal: 0,

  // Datos del response (6 arreglos)
  sucursales: [],        // Arreglo 1
  metricasSuc: [],       // Arreglo 2
  metricasGen: [],       // Arreglo 3
  cuponesSuc: [],        // Arreglo 4
  cuponesGen: [],        // Arreglo 5
  meseros: [],           // Arreglo 6
  origenClientes: [],    // Arreglo 7
  meserosRegistro: [],   // Arreglo 8

  /**
   * Cambia los filtros de fecha o sucursal y recarga los datos.
   */
  cambiarFiltros: async (filtros) => {
    set((state) => ({ ...state, ...filtros }));
    await get().obtenerMetricas();
  },

  /**
   * Consume el endpoint con los filtros actuales del store.
   */
  obtenerMetricas: async () => {
    const { fechaInicio, fechaFin, idSucursal } = get();
    set({ isLoading: true, error: null });
    try {
      const response = await fetch(
        `/p_metricas?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&idSucursal=${idSucursal}`
      );
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const json = await response.json();

      // El endpoint retorna { status, data } → data es el array con los 6 sub-arreglos
      const payload = json?.data ?? json;
      const [
        sucursales = [],
        metricasSuc = [],
        metricasGen = [],
        cuponesSuc = [],
        cuponesGen = [],
        meseros = [],
        origenClientes = [],
        meserosRegistro = [],
      ] = Array.isArray(payload) ? payload : [];

      set({
        sucursales,
        metricasSuc,
        metricasGen,
        cuponesSuc,
        cuponesGen,
        meseros,
        origenClientes,
        meserosRegistro,
        isLoading: false,
      });
    } catch (err) {
      console.error('[dashboardStore] Error al obtener métricas:', err);
      set({ isLoading: false, error: err.message });
    }
  },

  iniciar: async () => {
    await get().obtenerMetricas();
  },

  limpiar: () => {
    const { mes, anio } = getMesActual();
    set({
      isLoading: true,
      error: null,
      mesSeleccionado: mes,
      anioSeleccionado: anio,
      sucursales: [],
      metricasSuc: [],
      metricasGen: [],
      cuponesSuc: [],
      cuponesGen: [],
      meseros: [],
      origenClientes: [],
      meserosRegistro: [],
    });
  },
}));

export default dashboardStore;
